var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 3H5.5C4.39543 3 3.5 3.89543 3.5 5V19C3.5 20.1046 4.39543 21 5.5 21H19.5C20.6046 21 21.5 20.1046 21.5 19V5C21.5 3.89543 20.6046 3 19.5 3ZM5.5 2C3.84315 2 2.5 3.34315 2.5 5V19C2.5 20.6569 3.84315 22 5.5 22H19.5C21.1569 22 22.5 20.6569 22.5 19V5C22.5 3.34315 21.1569 2 19.5 2H5.5ZM18.5 10H17.5V19H18.5V10ZM12 13H13V19H12V13ZM6.5 16H7.5V19H6.5V16ZM14.5 5H18.5V8.5H17.5V6.6988C13.4767 10.5372 8.60479 12.1561 6.58212 12.4932L6.41772 11.5068C8.27663 11.197 12.9359 9.65793 16.7837 6H14.5V5ZM17.5 6V6.00008L17.4999 6H17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketIcon);
export default __webpack_public_path__ + "static/media/marketIcon.80a39a57a39866eebe9ce6df7f73dd2f.svg";
export { ForwardRef as ReactComponent };